import React from 'react'
import { ComponentParams, ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-nextjs'

export interface SettingsFields {
  data: {
    datasource: {
      showInServiceTitle: {
        field: Field<boolean>
      }
    }
  }
}

export interface SettingsProps {
  rendering: ComponentRendering & { params: ComponentParams }
  params: ComponentParams
  fields: SettingsFields
}

export const ADFSettings = (props: SettingsProps): JSX.Element => {
  return (
    <></>
  )
}

export default ADFSettings
